import { useNavigate } from "react-router-dom";
import {
  ArrowRight, Check, CalendarDays, Users, Megaphone, Repeat2, Sparkles,
  MessageCircle, BookOpen, Target, Heart, BarChart3, ClipboardCheck, LayoutGrid
} from "lucide-react";

const CHECKOUT_URL = process.env.REACT_APP_UPSELL_CHECKOUT_URL || "";

const modules = [
  ["01", "Estruture seu negócio para vender melhor", "Organize serviços, horários, preços, regras, sinal, agenda e fluxo de atendimento usando o NailControl."],
  ["02", "Pare de depender só de indicação", "Crie uma rotina simples de divulgação para gerar movimento e oportunidades de agendamento."],
  ["03", "Conteúdo que leva ao agendamento", "Saia do “postar por postar” e use desejo, prova, autoridade, oferta e CTA com intenção."],
  ["04", "Transforme inspiração em venda", "Use o catálogo de inspirações para facilitar escolhas, apresentar adicionais e aumentar valor percebido."],
  ["05", "Experiência que aumenta valor percebido", "Organize pré-atendimento, recepção, atendimento e pós-atendimento para entregar uma experiência mais profissional."],
  ["06", "Faça a cliente voltar", "Crie rotina de manutenção, retorno, aniversário, reativação e acompanhamento de clientes inativas."],
  ["07", "Venda pelo WhatsApp sem parecer desesperada", "Use scripts para orçamento, objeções, cliente que some, pedido de desconto, fechamento e retomada de conversa."],
  ["08", "Sua semana comercial pronta", "Tenha uma rotina prática para organizar, divulgar, reativar, vender e acompanhar o que está funcionando."]
];

const bonuses = [
  [Megaphone, "30 Campanhas para Movimentar a Agenda", "Campanhas para agenda aberta, encaixes, manutenção, reativação, indicação, datas especiais e muito mais."],
  [MessageCircle, "Scripts de Conversão no WhatsApp", "Mensagens prontas para orçamento, objeções, retomada de conversa, fechamento e retorno."],
  [ClipboardCheck, "Checklist Studio Profissional", "Um checklist para revisar os pontos que aumentam organização, clareza e percepção de profissionalismo."],
  [BarChart3, "Painel de Metas", "Acompanhe meta mensal, ticket médio, quantidade de atendimentos e evolução do negócio."]
];

const plan = [
  "Configurar o NailControl e revisar sua estrutura",
  "Organizar serviços, preços, horários e autoagendamento",
  "Preparar sua base de clientes e oportunidades de retorno",
  "Criar conteúdo com intenção de venda",
  "Usar stories, catálogo e campanhas para gerar desejo",
  "Reativar clientes antigas e facilitar o próximo agendamento",
  "Acompanhar resultados e repetir o que funciona"
];

export default function Upsell() {
  const nav = useNavigate();

  const accept = () => {
    if (CHECKOUT_URL) {
      window.location.href = CHECKOUT_URL;
      return;
    }
    nav("/oferta/downsell");
  };

  return (
    <div className="min-h-screen bg-[#FFFDFC] text-[#27272A]">
      <main>
        <section className="max-w-6xl mx-auto px-4 pt-10 pb-14 md:pt-16 md:pb-20">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center gap-2 rounded-full bg-[#EBF2EE] text-[#365F48] px-3 py-1.5 text-xs font-extrabold uppercase tracking-wider">
              <Check size={14} /> Seu NailControl está garantido
            </div>

            <div className="mt-5 text-xs font-extrabold uppercase tracking-[.2em] text-[#A84F67]">
              Oferta especial pós-compra
            </div>

            <h1 className="font-display text-4xl md:text-6xl font-extrabold leading-[1.03] mt-3">
              Agora transforme organização em
              <span className="text-[#A84F67]"> crescimento.</span>
            </h1>

            <p className="text-lg md:text-xl text-[#6F696D] mt-5 leading-relaxed max-w-3xl mx-auto">
              Você já tem as ferramentas. O <b>Nail Designer 360</b> mostra como usar agenda, conteúdo,
              experiência e relacionamento com clientes em uma rotina simples para movimentar seu negócio.
            </p>
          </div>

          <div className="mt-10 rounded-[36px] overflow-hidden border border-[#E8DDD8] shadow-[0_26px_80px_rgba(104,47,62,.11)]">
            <div className="grid lg:grid-cols-[1.15fr_.85fr]">
              <div className="bg-[#682F3E] text-white p-7 md:p-10">
                <div className="flex items-center gap-2 text-[#EBD8D2] text-xs font-bold uppercase tracking-wider">
                  <Sparkles size={15} /> Nail Designer 360
                </div>

                <h2 className="font-display text-3xl md:text-5xl font-extrabold mt-3">
                  Organizar. Atrair. Converter. Encantar. Fazer voltar.
                </h2>

                <p className="text-[#EBD8D2] mt-4 leading-relaxed text-lg">
                  Um método prático para transformar tudo o que você acabou de adquirir em uma rotina comercial
                  mais clara, consistente e profissional.
                </p>

                <div className="grid sm:grid-cols-5 gap-2 mt-7">
                  {["Organizar", "Atrair", "Converter", "Encantar", "Fazer voltar"].map((item, index) => (
                    <div key={item} className="rounded-2xl border border-white/15 bg-white/8 px-3 py-4 text-center">
                      <div className="text-xs text-[#EBD8D2]">0{index + 1}</div>
                      <div className="font-bold mt-1 text-sm">{item}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="bg-white p-7 md:p-10 flex flex-col justify-center">
                <div className="text-xs font-extrabold uppercase tracking-[.2em] text-[#A84F67]">
                  Adicione ao seu pedido
                </div>
                <div className="font-display text-5xl md:text-6xl font-extrabold text-[#682F3E] mt-3">
                  R$ 67,90
                </div>
                <div className="text-sm text-[#71717A] mt-1">pagamento único</div>

                <button
                  onClick={accept}
                  className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-2xl bg-[#682F3E] text-white font-extrabold px-6 py-4 hover:bg-[#542431] transition shadow-[0_12px_35px_rgba(104,47,62,.2)]"
                >
                  SIM, QUERO IMPLEMENTAR O MÉTODO 360 <ArrowRight size={18} />
                </button>

                <button
                  onClick={() => nav("/oferta/downsell")}
                  className="mt-4 text-sm text-[#817A7D] underline underline-offset-4"
                >
                  Não, quero continuar sem o Nail Designer 360
                </button>

                <div className="mt-5 flex items-start gap-2 text-sm text-[#6F696D]">
                  <Check size={16} className="text-[#4F7A61] mt-0.5 shrink-0" />
                  Seu acesso ao NailControl continua garantido mesmo se você não adicionar esta oferta.
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#FAF5F2] border-y border-[#EEE4DE]">
          <div className="max-w-6xl mx-auto px-4 py-16 md:py-20">
            <div className="max-w-3xl">
              <div className="text-xs font-extrabold uppercase tracking-[.2em] text-[#A84F67]">O método completo</div>
              <h2 className="font-display text-3xl md:text-5xl font-extrabold mt-3">
                8 módulos para conectar todas as peças do seu negócio.
              </h2>
              <p className="text-lg text-[#6F696D] mt-4">
                O objetivo não é entregar mais arquivos. É mostrar como transformar as ferramentas em execução.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-4 mt-10">
              {modules.map(([number, title, text]) => (
                <div key={number} className="bg-white rounded-3xl border border-[#ECE3DE] p-6">
                  <div className="flex gap-4">
                    <div className="w-11 h-11 rounded-2xl bg-[#F5ECE8] text-[#682F3E] flex items-center justify-center font-extrabold shrink-0">
                      {number}
                    </div>
                    <div>
                      <h3 className="font-display font-extrabold text-xl">{title}</h3>
                      <p className="text-[#6F696D] mt-2 leading-relaxed">{text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-6xl mx-auto px-4 py-16 md:py-20">
          <div className="grid lg:grid-cols-[.9fr_1.1fr] gap-8 items-center">
            <div className="rounded-[32px] bg-[#2D1E22] text-white p-7 md:p-9">
              <div className="flex items-center gap-2 text-[#EBD8D2] text-xs font-bold uppercase tracking-wider">
                <CalendarDays size={15} /> Plano Nail Designer 30 Dias
              </div>
              <h2 className="font-display text-3xl md:text-4xl font-extrabold mt-3">
                Você não vai precisar pensar “por onde eu começo?”
              </h2>
              <p className="text-[#D7C8CC] mt-4 leading-relaxed">
                O plano transforma o método em uma sequência de implementação para você avançar etapa por etapa.
              </p>

              <div className="space-y-3 mt-6">
                {plan.map((item, index) => (
                  <div key={item} className="flex gap-3 items-start rounded-2xl border border-white/10 bg-white/7 p-3">
                    <div className="w-7 h-7 rounded-full bg-white/12 flex items-center justify-center text-xs font-bold shrink-0">
                      {index + 1}
                    </div>
                    <span className="text-sm text-[#EFE6E8] pt-1">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="text-xs font-extrabold uppercase tracking-[.2em] text-[#A84F67]">Como tudo se conecta</div>
              <h2 className="font-display text-3xl md:text-5xl font-extrabold mt-3">
                Os materiais deixam de ser arquivos soltos e passam a fazer parte de uma estratégia.
              </h2>

              <div className="space-y-4 mt-7">
                {[
                  [LayoutGrid, "NailControl", "organiza agenda, clientes, preços e financeiro."],
                  [Megaphone, "Pack de Stories", "ajuda a divulgar horários e gerar desejo."],
                  [BookOpen, "Calendário de Conteúdo", "mostra o que publicar e com qual intenção."],
                  [Target, "100 Inspirações de Unhas", "ajuda a apresentar opções, gerar desejo e facilitar a escolha."],
                  [Heart, "Experiência que Valoriza", "melhora a percepção de profissionalismo antes, durante e depois do atendimento."],
                  [Repeat2, "Nail Designer 360", "ensina como usar tudo junto para atrair, converter, encantar e fazer clientes voltarem."]
                ].map(([Icon, title, text]) => (
                  <div key={title} className="flex gap-3 items-start">
                    <div className="w-11 h-11 rounded-2xl bg-[#F5ECE8] text-[#682F3E] flex items-center justify-center shrink-0">
                      <Icon size={20} />
                    </div>
                    <div>
                      <div className="font-bold">{title}</div>
                      <div className="text-[#6F696D] mt-1">{text}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-[#F5ECE8]">
          <div className="max-w-6xl mx-auto px-4 py-16 md:py-20">
            <div className="text-center max-w-3xl mx-auto">
              <div className="text-xs font-extrabold uppercase tracking-[.2em] text-[#A84F67]">Você ainda recebe</div>
              <h2 className="font-display text-3xl md:text-5xl font-extrabold mt-3">4 bônus para acelerar a implementação.</h2>
            </div>

            <div className="grid sm:grid-cols-2 gap-4 mt-10">
              {bonuses.map(([Icon, title, text], index) => (
                <div key={title} className="bg-white rounded-3xl border border-[#E8DDD8] p-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 rounded-2xl bg-[#682F3E] text-white flex items-center justify-center shrink-0">
                      <Icon size={21} />
                    </div>
                    <div>
                      <div className="text-xs font-extrabold uppercase tracking-wider text-[#A84F67]">Bônus {index + 1}</div>
                      <h3 className="font-display font-extrabold text-xl mt-1">{title}</h3>
                      <p className="text-[#6F696D] mt-2 leading-relaxed">{text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-5xl mx-auto px-4 py-16 md:py-20">
          <div className="rounded-[36px] bg-[#682F3E] text-white p-7 md:p-12 text-center shadow-[0_28px_90px_rgba(104,47,62,.2)]">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-[#F2E4E6]">
              <Sparkles size={14} /> Nail Designer 360
            </div>

            <h2 className="font-display text-3xl md:text-5xl font-extrabold mt-5">
              Você já tem as ferramentas. Agora tenha o método para usar tudo junto.
            </h2>

            <p className="text-[#EBD8D2] text-lg mt-4 max-w-2xl mx-auto">
              Organize sua rotina, transforme conteúdo em intenção de venda, melhore a experiência e crie ações para fazer clientes voltarem.
            </p>

            <div className="mt-8">
              <div className="text-sm text-[#EBD8D2]">adicione agora por</div>
              <div className="font-display text-6xl md:text-7xl font-extrabold mt-1">R$ 67,90</div>
              <div className="text-sm text-[#EBD8D2] mt-2">pagamento único</div>
            </div>

            <button
              onClick={accept}
              className="mt-8 inline-flex items-center justify-center gap-2 rounded-2xl bg-white text-[#682F3E] font-extrabold px-7 py-4 hover:bg-[#FFF7F4] transition min-w-[280px]"
            >
              SIM, QUERO IMPLEMENTAR O MÉTODO 360 <ArrowRight size={18} />
            </button>

            <button
              onClick={() => nav("/oferta/downsell")}
              className="block mx-auto mt-5 text-sm text-[#EBD8D2] underline underline-offset-4"
            >
              Não, seguir sem o Nail Designer 360
            </button>
          </div>

          <p className="text-xs text-[#8A8386] text-center max-w-2xl mx-auto mt-7">
            O Nail Designer 360 é um produto educacional. Resultados dependem de aplicação, oferta, mercado, rotina e contexto de cada profissional.
          </p>
        </section>
      </main>
    </div>
  );
}
